export default __webpack_public_path__ + "static/media/Designo - Preview 1.2f88ec5c.png";